import { useState, useCallback } from 'react'
import type { OnboardingState, WorkspaceData } from '../types'

export function useOnboarding() {
  const [state, setState] = useState<OnboardingState>({
    workspace: { workspaceName: '', industry: '', teamSize: '' },
  })

  const updateWorkspace = useCallback((data: Partial<WorkspaceData>) => {
    setState((prev) => ({ ...prev, workspace: { ...prev.workspace, ...data } }))
  }, [])

  return {
    workspace: state.workspace,
    updateWorkspace,
  }
}
